import React from "react";
import styles from "./HeroSectionStyles.module.css";
function HeroSection() {
  return (
    <section className={styles.heroSection}>
      {/* Video Background
      <video autoPlay loop muted playsInline className={styles.videoBackground}>
        <source
          src="https://t9018597001.p.clickup-attachments.com/t9018597001/3178e02c-4d5f-4ea4-9510-deac156c8255/Gen-3%20Alpha%202385637106%2C%20Create%20a%2015%20sec%20anim%2C%20image-prompt%2C%20M%205.mp4?view=open"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video> */}
      {/* Content */}
      <div className={styles.content}>
        <h1>Your AI gateway to investor insights on the S&P 100.</h1>
        <p>
          Discover and engage with the latest reports and updates from the
          world’s leading companies.
        </p>
      </div>
    </section>
  );
}

export default HeroSection;
